export const SENSOR = {
	SCREEN_PIXEL_RATIO: 'screenPixelRatio',
	WINDOW_WIDTH:       'windowWidth',
	WINDOW_HEIGHT:      'windowHeight',
	ORIENTATION:        'orientation',
	VIEWPORT:           'viewport',
	FULLSCREEN:         'fullscreen',
	TOUCH:              'touch',
	BREAKPOINT:         'breakpoint',
};

export const ORIENTATION = {
	LANDSCAPE: 'landscape',
	PORTRAIT:  'portrait',
};
